<template>
    <div class="row mt-2">
        <div class="toggle-item col-6 toggle" :class="toggledHomeDelivery == false ? 'active' : ''">
            <div class="inner">
                <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" @change="toggleRoute(0)" :value="false" v-model="this.toggledHomeDelivery">
                <label class="form-check-label" for="flexRadioDefault1">
                    Fully fitted
                </label>
            </div>
        </div>
        <div class="toggle-item col-6" :class="toggledHomeDelivery == true ? 'active' : ''">
            <div class="inner">
                <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" @change="toggleRoute(1)" :value="true" v-model="this.toggledHomeDelivery">
                <label class="form-check-label" for="flexRadioDefault2">
                    Tyre delivery
                </label>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['homeDelivery'],
        components: {

        },
        data() {
            return {
                toggledHomeDelivery: this.homeDelivery,
            }
        },
        methods: {
            toggleRoute: function(data) {
                let vm = this;
                axios.post('/ajax/toggle_home_delivery_route/' + data)
                .then(response => {
                    vm.$emit('rangeRouteToggled', data);
                })
                .catch(error => {
                    console.error("There was an error!", error);
                });
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>